import React, { useEffect, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { useSelector } from "react-redux";

// import pages
import Header from "./pages/layout/Header";
import Main from "./pages/layout/Main";
import Footer from "./pages/layout/Footer";
import Modal from "./pages/modal/Modal";

// style
import "./App.css";

const App = () => {
  const loading = useSelector((state) => state.loading.loading);
  const [theme, setTheme] = useState(() => {
    const savedTheme = window.localStorage.getItem("lovapex-theme");

    if (savedTheme === "light" || savedTheme === "dark") {
      return savedTheme;
    }

    return "light";
  });

  useEffect(() => {
    document.documentElement.dataset.theme = theme;
    document.documentElement.style.colorScheme = theme;
    window.localStorage.setItem("lovapex-theme", theme);
  }, [theme]);

  const toggleTheme = () => {
    setTheme((currentTheme) => (currentTheme === "dark" ? "light" : "dark"));
  };

  return (
    <Router>
      <div>
        <Header theme={theme} onToggleTheme={toggleTheme} />
        <Main />
        <Footer />
        {loading && <Modal />}
      </div>
    </Router>
  );
};

export default App;
